import {
  FaShieldAlt,
  FaUserPlus,
  FaUsers,
  FaUserClock,
  FaUserCog,
} from "react-icons/fa";

export const SUPER_ADMIN_USER_MANAGEMENT_ITEMS = [
  {
    id: "sa_users_all",
    label: "Users",
    to: "/super-admin/users",
    icon: FaUsers,
    end: true,
  },
  {
    id: "sa_users_create",
    label: "Create User",
    to: "/super-admin/users/create",
    icon: FaUserPlus,
    end: true,
  },
  {
    id: "sa_users_pending",
    label: "Pending Invitations",
    to: "/super-admin/users?status=Pending",
    icon: FaUserClock,
    end: true,
  },
];

export const SUPER_ADMIN_ROLE_MANAGEMENT_ITEMS = [
  {
    id: "sa_roles_all",
    label: "Roles",
    to: "/super-admin/roles",
    icon: FaShieldAlt,
    end: true,
    activePathPrefix: "/super-admin/roles",
  },
  {
    id: "sa_roles_create",
    label: "Create Role",
    to: "/super-admin/roles/create",
    icon: FaUserCog,
    end: true,
  },
];

export const SUPER_ADMIN_USER_MANAGEMENT_GROUP = {
  id: "user_management",
  heading: "User Creation",
  icon: FaUsers,
  items: SUPER_ADMIN_USER_MANAGEMENT_ITEMS,
};

export const SUPER_ADMIN_ROLE_MANAGEMENT_GROUP = {
  id: "role_management",
  heading: "Role Creation",
  icon: FaShieldAlt,
  items: SUPER_ADMIN_ROLE_MANAGEMENT_ITEMS,
};
